import axios from '../helpers/axios'
import { logError } from '../services';
import {
  IStartSheetTemplateCategoryResponse,
  IStartSheetTemplateResponse,
  IStartSheetTemplateDetailCreateUpdate,
  IStartSheetTemplateDetail
} from '../models/startsheettemplates';

export const getStartSheetTemplates = async (
  type: string,
  filters?: { page?: number; perPage: number; sortBy: string }
): Promise<IStartSheetTemplateResponse> => {
  try {
    const { data } = await axios.get(`/api/startsheettemplates/${type}`, { params: filters });
    return data;
  } catch (error) {
    logError(error, 'getStartSheetTemplates failed');
    return Promise.reject(error);
  }
};

export const getStartSheetTemplateDetail = async (
  sheetId: number
): Promise<IStartSheetTemplateDetail> => {
  try {
    const { data } = await axios.get(`/api/startsheettemplates/${sheetId}`);
    return data;
  } catch (error) {
    logError(error, 'getStartSheetTemplateDetail failed');
    return Promise.reject(error);
  }
};

export const createStartSheetTemplate = async (
  type: string,
  post: IStartSheetTemplateDetailCreateUpdate
): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/startsheettemplates/${type}`, post);
    return data;
  } catch (error) {
    logError({ error, payload: { type, post } }, 'createStartSheetTemplate failed');
    return Promise.reject(error?.response?.data);
  }
};

export const updateStartSheetTemplate = async (
  sheetId: number,
  post: IStartSheetTemplateDetailCreateUpdate
): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/startsheettemplates/${sheetId}`, post);
    return data;
  } catch (error) {
    logError({ error, payload: { sheetId, post } }, 'updateStartSheetTemplate failed');
    return Promise.reject(error?.response?.data);
  }
};

export const deleteStartSheetTemplate = async (sheetId: number): Promise<any> => {
  try {
    const { data } = await axios.delete(`/api/startsheettemplates/${sheetId}`);
    return data;
  } catch (error) {
    logError(error, 'deleteStartSheetTemplate failed');
    return Promise.reject(error);
  }
};

export const getStartSheetTemplateCategories = async (
  type: string,
  filters?: { page?: number; perPage: number; sortBy: string; sortDirection: string }
): Promise<IStartSheetTemplateCategoryResponse> => {
  try {
    const { data } = await axios.get(`/api/startsheettemplates/${type}/categories`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getStartSheetTemplateCategories failed');
    return Promise.reject(error);
  }
};
